import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';

interface GuestOption {
  id: string;
  name: string;
}

interface GuestFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

const guestOptions: GuestOption[] = [
  { id: '', name: 'All' },
  { id: 'yes', name: 'Yes' },
  { id: 'no', name: 'No' },
];

export const GuestFilter: React.FC<GuestFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedOption =
    guestOptions.find((o) => o.id === value) || guestOptions[0];

  if (valueOnly) {
    return (
      <>
        {label}: {selectedOption.name}
      </>
    );
  }

  return (
    <Autocomplete
      options={guestOptions}
      getOptionLabel={(option) => option.name}
      value={selectedOption}
      onChange={(_, newValue) => {
        setValue(newValue?.id || '');
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select Option" />
      )}
    />
  );
};
